import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { SERVICE_LIST_DATA } from './data/serviceListData';
import { Text } from '../../../shared/components/Text';

const useStyle = makeStyles(theme => ({
  listStyle: {
    padding: 0,
    margin: 0,
  },
  itemStyle: {
    paddingBottom: 20,
  },
}));

const Item = ({ label }) => {
  const styles = useStyle();
  return (
    <li className={styles.itemStyle}>
      <Text variant="body1" bold style={{ fontSize: 18 }}>
        <Trans>{label}</Trans>
      </Text>
    </li>
  );
};

export const ServiceList = () => {
  const styles = useStyle();
  return (
    <ul className={styles.listStyle}>
      {SERVICE_LIST_DATA.map(({ label }, i) => (
        <Item key={i} label={label} />
      ))}
    </ul>
  );
};

Item.propTypes = {
  label: PropTypes.string.isRequired,
};
